const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const NormativGrid = [
    { field: 'id', headerName: '#', width: 60, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'barcode', headerName: 'Barkodi', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'name', headerName: 'Emertimi', width: 515, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'unit', headerName: 'Njesia', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'articleType',
        headerName: 'Lloji artikullit',
        width: 200,
        editable: false,
        headerClassName: 'super-app-theme--header',
        groupable: false,
        aggregable: false,
        filterType: 'select',
        filterOptions: [
            { value: '2', label: 'Gjysëm Produkt' },
            { value: '3', label: 'Produkt i Prodhuar' },
        ],
    }
]

export const gridHeader = [
    { field: 'id', headerName: '#', width: 75, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'barcode', headerName: 'Barkodi', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'name', headerName: 'Emertimi', width: 500, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'unit', headerName: 'Njesia', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'qty', headerName: 'Sasia', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
]